"use client";

import React from "react";
import styled from "styled-components";
import { spacing4 } from "@churchofjesuschrist/eden-style-constants";
import { jsx as _jsx } from "react/jsx-runtime";
const Root = styled.div.withConfig({
  componentId: "sc-v99oco-0"
})(["display:flex;flex-flow:row wrap;margin:calc(-1 * ", ");& > :is(a,button,div){margin:", ";}"], spacing4, spacing4);

/**
 * A row of actions a user can take to interact with the content on a page.
 * @param {object} props - The component props
 * @param {React.ReactNode} props.children - Content to render inside the `ActionBar`
 * @returns {React.ReactNode} The ActionBar component
 */
const ActionBar = props => /*#__PURE__*/_jsx(Root, {
  ...props
});
ActionBar.displayName = "ActionBar";
export default ActionBar;